import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'empty-state',
  standalone: false,
  templateUrl: './empty-state.component.html',
})
export class EmptyStateComponent implements OnInit {

  @Input() title!: string;
  @Input() subTitle: string = '';
  @Input() desc: string = '';
  @Input() img: string = '';
  @Input() animationPath: string = '';
  @Input() custClass: string = '';
  options: AnimationOptions | null = null;

  @Input() btnClass!: string;
  @Output() eventEmit = new EventEmitter<any>();
  @Input() link!: string;
  @Input() linkBoolean!: boolean;

  @Input() hideTitle!: boolean;

  constructor(private translate: TranslateService) {
    if (!this.title) {
      this.title = this.translate.instant('general.No Data Found');
    }
  }

  ngOnInit(): void {
    this.options = {
      path: this.animationPath || '/assets/js/empty-state-animated.json',
      loop: false,
    };
  }

  evEmit() {
    this.eventEmit.emit();
  }

}
